import { render, staticRenderFns } from "./RespChurchManagePage.vue?vue&type=template&id=257229b6&scoped=true&"
import script from "./RespChurchManagePage.vue?vue&type=script&lang=js&"
export * from "./RespChurchManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257229b6",
  null
  
)

export default component.exports